import { Directive, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { ChipComponent } from '@shared/chip/chip.component';
import { ProjectSection } from '../models/access.models';
import { AccessService } from '../services/access.service';

/**
 * Directive: PermChipDirective
 *
 * Автоматически блокирует (устанавливает `isLock=true`) компонент `app-chip`
 * если текущий пользователь не имеет права `<section>:edit`.
 * Работает аналогично уже существующим директивам `PermSelectDirective`
 * и `PermFormDirective`. Секция берётся из `data['section']` маршрута.
 * Директива подключается через `AccessUiModule` и применяется к каждому
 * `app-chip` в шаблонах без дополнительного кода.
 */
@Directive({ selector: 'app-chip' })
export class PermChipDirective implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();
  private _weLocked = false;

  constructor(
    @Optional() @Self() private readonly _chip: ChipComponent,
    private readonly _route: ActivatedRoute,
    private readonly _access: AccessService,
  ) {}

  ngOnInit(): void {
    const data = this._route.snapshot.data ?? {};
    const section = data['section'] as ProjectSection | undefined;
    if (!section || data['skipPermDisable'] || !this._chip) return;

    this._access
      .can$(section, 'edit')
      .pipe(takeUntil(this._destroy$))
      .subscribe((canEdit) => {
        if (!canEdit) {
          this._chip.isLock = true;
          this._weLocked = true;
        } else if (this._weLocked) {
          this._chip.isLock = false;
          this._weLocked = false;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
